module.exports = __webpack_public_path__ + "static/media/ally-II-ups-image.e0148769.png";